import * as React from 'react';
import { useState, useEffect } from 'react';
import { Toast, ToastBody, ToastHeader, Spinner } from 'reactstrap';
import parse from 'html-react-parser';

const ToastReporter = (props: {
    topic: string;
    style: string;
    details: any[];
    showReadMoreMaxChars: number;
    /*If 0 Do not show the Read More link, any value >0 show the link to read more */

}) => {
    //TODO create a generic reporter component to actually render the topic and details.
    //props should include title and detail list
    const [readMore, setReadMore] = useState(false);

    const detailCount = function () {
        var detailString = ""
        var str = props.details.map((e) => {

            detailString = detailString + e.key + e.value;
        })
        return detailString.length;
    }

    const showTruncatedInformation = function () {
        var detailString = ""
        var str = props.details.map((e) => {

            detailString = detailString + e.key + e.value;
        })
        return detailString.length;
    }

    const linkName = readMore ? 'Read More >> ' : 'Read Less << '

    const readMoreInformation = function () {
        let render: string[] = [];
        var chars = "";
        var line = "";
        render.push('<ul>');

        const options = props.details.map((detail) => {
            line = detail.key.trim() + (detail.key.trim().length > 0 ? ": " : "") + detail.value;
            if (detail.key.endsWith("URI")) {
                if ((chars.length + line.length) > props.showReadMoreMaxChars) {

                    render.push('<li><a href="' + detail.value + '" target="_blank">' + line.substring(0, props.showReadMoreMaxChars - chars.length) + ' .... </a></li>');
                    return;
                } else {
                    render.push('<li><a href="' + detail.value + '" target="_blank">' + line + '</a></li>');
                }
            } else {
                if ((chars.length + line.length) > props.showReadMoreMaxChars) {

                    render.push('<li>' + line.substring(0, props.showReadMoreMaxChars - chars.length) + ' .... </li>');
                    return;
                } else {
                    render.push('<li>' + line + '</li>');
                }
            }
            chars = chars + line;

        })
        render.push('</ul>');
        var str = render.join('');

        return (
            <>
                <div>
                    {parse(str)}
                </div>
                <a className="read-more-link" onClick={() => { setReadMore(!readMore) }}>{linkName}</a>
            </>
        );
    }
    const getLineKey = function (lkey: string): string {
        if (lkey.trim().length > 0) {
            return lkey + ":";
        }
        return "";
    }
    const readLessInformation = function () {
        return (
            <>
                <ul>
                    {props.details.map((detail, i) => {
                        if (detail.key.endsWith("URI")) {
                            return <li key={detail.key + i}>{getLineKey(detail.key)} <a href={detail.value} target="_blank">{detail.value}</a></li>
                        }
                        if (!detail.value) {
                            return <li key={detail.key + i}>{getLineKey(detail.key)}</li>;
                        }
                        if (detail.value.toString().indexOf("<br>") >= 0) {
                            return <li key={detail.key + i}>{getLineKey(detail.key)} {parse(detail.value)}</li>;
                        }
                        return <li key={detail.key + i}>{getLineKey(detail.key)} {detail.value}</li>
                    }
                    )}
                </ul>
                {(props.showReadMoreMaxChars > 0) && (detailCount() > props.showReadMoreMaxChars) && (<a className="read-more-link" onClick={() => { setReadMore(!readMore) }}>{linkName}</a>)}
            </>
        );
    }

    const showDetail = function () {

        if (props.showReadMoreMaxChars > 0) {
            if (readMore && detailCount() > props.showReadMoreMaxChars) {
                return readMoreInformation()
            }

        }
        return readLessInformation()
    }


    useEffect(() => {

        setReadMore(true)

    }, [props])

    return (
        <div>
            <Toast className={props.style}>
                <ToastHeader className={props.style}>{props.topic}</ToastHeader>
                <ToastBody>
                    {showDetail()}
                </ToastBody>
            </Toast>
        </div>
    )
}

export default ToastReporter;